<template>
  <div class="row mb-3">
    <div
      class="col-sm-12 col-md-4 col-lg-4"
      style="width: -webkit-fill-available !important;"
    >
      <div class="card mb-0 h-100">
        <ChartDonut
          :title-chart="'Top 5 Product Sales'"
          :chart-data="overviewData.total_sales_product"
          :sub-text-chart="'Product Sales'"
          :is-format-number="'two'"
          :position-label="'right'"
        />
      </div>
    </div>
    <div
      class="col-sm-12 col-md-4 col-lg-4"
      style="width: -webkit-fill-available !important;"
    >
      <div class="card mb-0 h-100">
        <ChartDonut
          :title-chart="'Top 5 Quantity By Category'"
          :chart-data="overviewData.sold_qty"
          :sub-text-chart="'Sold QTY'"
          :is-format-number="'zero'"
          :position-label="'left'"
        />
      </div>
    </div>
    <div
      class="col-sm-12 col-md-4 col-lg-4"
      style="width: -webkit-fill-available !important;"
    >
      <div class="card mb-0 h-100">
        <ChartDonut
          :title-chart="'Top 5 Sales by Category'"
          :chart-data="overviewData.orders_category"
          :sub-text-chart="'Total Sales'"
          :is-format-number="'two'"
          :position-label="'left'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ChartDonut from './ChartDonut.vue';

export default {
  name: "OverviewChart",
  components: {
    ChartDonut,
  },
  props: {
    overviewData: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  created() {
    // console.log(this.overviewData)
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/tenancy/admin/report/product/chart/category/OverviewChart.vue